
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4069_19790)"}},[_c('path',{attrs:{"d":"M0 1v3.6h1.368l.774 4.8H1.2V13h3.6v-1.164l3-.006V13h3.6V9.4h-1.098l.498-4.2H12V1.6H8.4v2.118l-.72.882H4.554L3.6 3.292V1H0zm1.2 1.2h1.2v1.2H1.2V2.2zm8.4.6h1.2V4H9.6V2.8zM2.586 4.6h.48L4.2 6.154V8.2h3.6V6.346L8.742 5.2H9.6l-.504 4.2H7.8v1.236h-3V9.4H3.36l-.774-4.8zM5.4 5.8h1.2V7H5.4V5.8zm-3 4.8h1.2v1.2H2.4v-1.2zm6.6 0h1.2v1.2H9","fill":"#000","fill-opacity":".7"}}),_c('rect',{attrs:{"x":"6.5","y":"7.5","width":"12","height":"11","rx":"5.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M8 9v3.3h1.14l.645 4.4H9V20h3v-1.067l2.5-.006V20h3v-3.3h-.915L17 12.85h1v-3.3h-3v1.941l-.6.809h-2.605L11 11.101V9H8zm1 1.1h1v1.1H9v-1.1zm7 .55h1v1.1h-1v-1.1zm-5.845 1.65h.4l.945 1.425V15.6h3v-1.7l.785-1.05H16l-.42 3.85H14.5v1.133H12V16.7h-1.2l-.645-4.4zm2.345 1.1h1v1.1h-1v-1.1zM10 17.8h1v1.1h-1v-1.1zm5.5 0h1v1.1h-1","fill":"#000","fill-opacity":".7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4069_19790"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    